import { render, staticRenderFns } from "./CharacterContain.vue?vue&type=template&id=1a601790&scoped=true&"
import script from "./CharacterContain.vue?vue&type=script&lang=js&"
export * from "./CharacterContain.vue?vue&type=script&lang=js&"
import style0 from "./CharacterContain.vue?vue&type=style&index=0&id=1a601790&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a601790",
  null
  
)

export default component.exports